module.exports = __webpack_public_path__ + "img/EmployeeCV.444a90c7.svg";